<button
  class="round-button"
  [ngStyle]="style"
  [attr.aria-pressed]="activeButton"
  (click)="clickOnButton($event)">
  {{title}}
</button>